export default defineNuxtComponent({

    setup() {
        const Router = useRouter();
        onMounted(() => {
            Router.replace('/dqjs/xxgcddesdjs')
        });
        return () => (
            <>郑州路桥建设投资集团 党群建设 加载中...</>
       )
    }
})